import { Middleware } from "redux";

import { setApplicantFormData } from "../../features/AC/Applicant/applicant.slice";
import { setIncidentFormData } from "../../features/AC/Incident/incident.slice";
import { setPerpetratorFormData } from "../../features/AC/Perpetrator/perpetrator.slice";
import { setVehicleFormData } from "../../features/AC/Vehicle/vehicle.slice";
import { setPropertyIncidentFormData } from "../../features/OC/Property/Incident/incident.slice";
import { setOwnerFormData } from "../../features/OC/Property/Owner/owner.slice";
import { setDamagesFormData } from "../../features/OC/Vehicle/Damages/damages.slice";
import { setVehicleOwnerFormData } from "../../features/OC/Vehicle/VehicleOwner/vehicleOwner.slice";
import { RootState } from "../rootReducer";

type Payload = { [key: string]: { [key: string]: unknown } };

const actions = [
  setApplicantFormData.type,
  setIncidentFormData.type,
  setPerpetratorFormData.type,
  setVehicleFormData.type,
  setVehicleOwnerFormData.type,
  setDamagesFormData.type,
  setPropertyIncidentFormData.type,
  setOwnerFormData.type,
];

export const removeUndefinedFieldsMiddleware: Middleware<
  unknown,
  RootState
> = () => (next) => (action) => {
  const { type, payload } = action;

  if (!actions.includes(type)) {
    return next(action);
  }

  const newPayload: Payload = {};
  for (const [key, values] of Object.entries(payload)) {
    if (typeof values !== "object" || !values) {
      newPayload[key] = values as Payload;
      continue;
    }

    for (const [valueKey, value] of Object.entries(values)) {
      if (value === undefined) {
        continue;
      }

      if (!newPayload[key]) {
        newPayload[key] = {};
      }

      newPayload[key][valueKey] = value;
    }
  }

  const actionWithRemovedUndefinedPayload = {
    ...action,
    payload: { ...newPayload },
  };

  return next(actionWithRemovedUndefinedPayload);
};
